import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';

@Component({
  selector: 'app-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span
      class="icon"
      role="img"
      [attr.aria-hidden]="ariaHidden()"
      [style.width.px]="size()"
      [style.height.px]="size()"
      [style.mask-image]="maskUrl()"
      [style.-webkit-mask-image]="maskUrl()"
    ></span>
  `,
  styles: `
    :host {
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    .icon {
      display: block;
      background-color: currentColor;
      mask-size: contain;
      mask-repeat: no-repeat;
      mask-position: center;
      -webkit-mask-size: contain;
      -webkit-mask-repeat: no-repeat;
      -webkit-mask-position: center;
    }
  `,
})
export class IconComponent {
  readonly name = input.required<string>();
  readonly size = input<number>(16);
  readonly ariaHidden = input<boolean>(true);

  readonly maskUrl = computed(() => `url(assets/icons/${this.name()}.svg)`);
}
